import UrlStoreContext from '@/modules/url-store/UrlStoreContext.tsx';
import { type UrlStoreState } from '@/modules/url-store/UrlStoreProvider';
import { useContext } from 'react';

export default function useUrlStore(): UrlStoreState {
  const storeContext: UrlStoreState = useContext(UrlStoreContext);
  return storeContext;
}
